import script from "./douyin.vue?vue&type=script&setup=true&lang=ts"
export * from "./douyin.vue?vue&type=script&setup=true&lang=ts"

import "./douyin.vue?vue&type=style&index=0&id=5f60d15c&lang=scss&scoped=true"

import exportComponent from "/Users/huangliu/Desktop/work/2024/develop/fdyun/ycx-website/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f60d15c"]])

export default __exports__